export default [
  {
    name: 'commoditie-id',
    path: 'commodities/:id',
    component: () => import(/* webpackChunkName: "commoditie-id" */ '@/views/Commoditie/Detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    name: 'pay-commoditie-id',
    path: 'commodities/:id/pay',
    component: () => import(/* webpackChunkName: "pay-commoditie-id" */ '@/views/Commoditie/Pay'),
    meta: {
      keepAlive: false
    }
  }
]
